import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';
import {Link} from 'react-router-dom';
import {Crew} from '../../../../Models/Crew';
import {disableExperimentalFragmentVariables} from '@apollo/client';

interface OwnProps {
    crew: Crew;
    className?: string;
}

export const MobileNavigation: FunctionComponent<OwnProps> = ({crew, className}) => {
    return (
        <div className={classNames('w-100 d-lg-none btn-group', className)} role="group">
            <Link
                to={'/crews/' + crew.id}
                className={classNames('btn', {
                    'btn-primary': window.location.pathname === '/crews/' + crew.id,
                    'btn-outline-primary': window.location.pathname !== '/crews/' + crew.id,
                })}
            >
                Overview
            </Link>
            <Link
                to={'/crews/' + crew.id + '/calendar'}
                className={classNames('btn', {
                    'btn-primary': window.location.pathname === '/crews/' + crew.id + '/calendar',
                    'btn-outline-primary': window.location.pathname !== '/crews/' + crew.id + '/calendar',
                })}
            >
                Calendar
            </Link>
        </div>
    );
};
